// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"c38ca4b6","48":"83e391c2","96":"0331400f","160":"10499e9a","226":"5fa8525b","852":"a07717bc"}[chunkId] + ".chunk.js";
};